module.exports = __webpack_public_path__ + "img/create-certif.e3e0e4df.svg";